/* eslint-disable max-classes-per-file */
import { sortingOrder } from '../../constants/common';

export default class EventTemplateBuilder {
  constructor(build) {
    this.id = build.id;
    this.name = build.name;
    this.description = build.description;
    this.type = build.type;
    this.multiqueryMode = build.multiqueryMode;
    this.sortingAxis = build.sortingAxis;
    this.sortingOrder = build.sortingOrder;
    this.showAverage = build.showAverage;
    this.showMedian = build.showMedian;
    this.showGrandTotal = build.showGrandTotal;
    this.formula = build.formula;
    this.queries = build.queries;
  }

  static builder() {
    return new EventTemplateBuilder.Builder();
  }
}

EventTemplateBuilder.Builder = class {
  constructor() {
    this.obj = {};
  }

  id(id) {
    this.obj.id = id;
    return this;
  }

  name(name) {
    this.obj.name = name;
    return this;
  }

  description(description) {
    this.obj.description = description;
    return this;
  }

  type(type) {
    this.obj.type = type;
    return this;
  }

  multiqueryMode(multiqueryMode) {
    if (multiqueryMode) {
      this.obj.multiqueryMode = 'SINGLE';
    } else {
      this.obj.multiqueryMode = 'MULTIPLE';
    }
    return this;
  }

  sortingAxis(sortingAxis) {
    this.obj.sortingAxis = sortingAxis;
    return this;
  }

  sortingOrder(order) {
    if (order === sortingOrder.DESCENDING) {
      this.obj.sortingOrder = 'DESC';
    } else {
      this.obj.sortingOrder = sortingOrder;
    }
    return this;
  }

  showAverage(showAverage) {
    this.obj.showAverage = showAverage;
    return this;
  }

  showMedian(showMedian) {
    this.obj.showMedian = showMedian;
    return this;
  }

  showGrandTotal(showGrandTotal) {
    this.obj.showGrandTotal = showGrandTotal;
    return this;
  }

  formula(formula) {
    this.obj.formula = formula;
    return this;
  }

  queries(queries) {
    this.obj.queries = queries;
    return this;
  }

  build() {
    return new EventTemplateBuilder(this.obj);
  }
};
